import { render, staticRenderFns } from "./homefire-policy-detail-info.vue?vue&type=template&id=1232928f&scoped=true&"
import script from "./homefire-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./homefire-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./homefire-policy-detail-info.vue?vue&type=style&index=0&id=1232928f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232928f",
  null
  
)

export default component.exports